export default __webpack_public_path__ + "856fb0cc7615715dd246604ff2cff1aa.svg";